<template>
  <div class="flex flex_between">
    <md-field :class="{ 'select-error': isError }">
      <label>{{this.$t('common.account')}}</label>
      <TbSelect v-model="moduleValue"
				@md-selected="onSelect"
				:search-allow="true"
				:options="options"
				options-value-field="id"
				:options-display-getter="(item) => item.iban + ' (' + item.currencyIsoCode + ')'"
				:required="required"
      />
    </md-field>
  </div>
</template>
<script>
import {dashboardInspectionApi} from "@/common/api/dashboardInspectionApi";

export default {
  props: {
    labelText: {
      type: String,
      default: "value"
    },
    isError: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      moduleValue: "",
      options: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    onSelect() {
      this.$emit("onSelect", this.moduleValue);

      let account = this.options.find(item => item.id === this.moduleValue);
      this.$store.dispatch("setActionDashboardFilter", {
        accountId: account ? account.id : "",
        currency: account ? account.currencyIsoCode: ""
      });
    },
    getList() {
      dashboardInspectionApi.buyer
        .accounts()
        .then(res => {
            if (res && res.length > 0) {
                this.options = res;
                this.moduleValue = res[0].id;
                this.onSelect();
            }
        })
        .catch(this.toast);
    }
  }
};
</script>
